import { Colors, Lightning } from '@lightningjs/sdk'

export default class Button extends Lightning.Component {
  static _template() {
    return {
      ButnWrapper: {
        w: w => w,
        h: h => h,
        ButnBG: {
          w: w => w,
          h: h => h,
          rect: true,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            w: w => w,
            h: h => h,
            fillColor: Colors('button')
              .alpha(0.4)
              .get(),
            stroke: 3,
            strokeColor: 0xffffffff,
          },
        },
        ButnText: {
          h: 34,
          mountY: 0.5,
          color: 0xffffffff,
          text: {
            text: '',
            fontFace: 'OpenSansRegular',
            fontSize: 25,
            wordWrap: false,
            lineHeight: 34,
          },
        },
      },
    }
  }

  set buttonText(txt) {
    this._butnText = txt

    this.tag('ButnText').patch({
      text: { text: txt },
    })
  }

  set padding(padding) {
    this._padding = padding
  }

  _init() {
    this._padding = 57

    this.tag('ButnText').on('txLoaded', () => {
      const wd = this.tag('ButnText').finalW + 20 + this._padding * 2

      this.patch({
        w: wd,
        ButnWrapper: {
          w: wd,
          ButnBG: { w: wd, shader: { w: this.w, h: this.h, radius: this.h / 2 } },
          ButnText: { x: this._padding + 10, y: this.h / 2 },
        },
      })

      this._setButtonBG(this.hasFocus())
    })
  }

  _setButtonBG(focus) {
    let btnColor, btnAlpha, strokeAlpha

    if (focus) {
      btnColor = 'ButtonFocus'
      btnAlpha = 1
      strokeAlpha = 1
    } else {
      btnColor = '#ffffff'
      btnAlpha = 0.4
      strokeAlpha = 0
    }

    this.tag('ButnBG').patch({
      shader: {
        fillColor: Colors(btnColor)
          .alpha(btnAlpha)
          .get(),
        strokeColor: Colors('white')
          .alpha(strokeAlpha)
          .get(),
      },
    })
  }

  _focus() {
    this._setButtonBG(true)
  }

  _unfocus() {
    this._setButtonBG(false)
  }
}
